var map = {
	"./en/example.yml": 152,
	"./en/hos.yml": 153,
	"./en/main.yml": 28,
	"./en/markdown.yml": 154,
	"./en/news.yml": 155,
	"./en/sfs.yml": 156,
	"./fr/example.yml": 157,
	"./fr/hos.yml": 158,
	"./fr/main.yml": 29,
	"./fr/markdown.yml": 159,
	"./fr/news.yml": 160,
	"./fr/sfs.yml": 161,
	"./hu/hos.yml": 162,
	"./hu/main.yml": 30,
	"./hu/sfs.yml": 163,
	"./oc/hos.yml": 164,
	"./oc/main.yml": 31,
	"./oc/sfs.yml": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;